import React from "react";
import LandingPageLayout from "../layout/LandingPageLayout";
import LandingPageForm from "./LandingPageForm";

import cellPhone from "../../../../img/landing-page/cellphone.png";

const LandingPageHowMuch = ({ submitted } = props) => {

	return (
		<LandingPageLayout id="how-much-my-miles" classAdd="offers-landing-page-how-much">
			<div className="offers-landing-page-how-much__content">
				<div className="offers-landing-page-how-much__content__header">
					<div className="offers-landing-page-how-much__content__header--text">
						<h2>VEJA QUANTO SUAS MILHAS ESTÃO VALENDO E VENDA AGORA!</h2>
						<p>
							Na MaxMilhas, você pode acompanhar o valor médio das ofertas de milhas feitas na
							plataforma por programa de fidelidade.
							<strong>
								{" "}
								Cadastre seu e-mail, receba dicas para acumular mais milhas e veja aqui a média dos
								últimos 7 dias.
							</strong>
						</p>
					</div>
					<img
						className="offers-landing-page-how-much__content__header--cellphone"
						alt=""
						src={cellPhone}
					/>
				</div>
				<LandingPageForm
					gaEventLabel="Cotacao"
					buttonText="QUANTO VALEM MINHAS MILHAS"
					buttonColor="green"
					id="offers-landing-page-form-how-much"
					icon="icon-miles"
					message="Agora você ficará por dentro do mundo das Milhas!"
					submitted={() => submitted()}
				/>
			</div>
		</LandingPageLayout>
	);
};

export default LandingPageHowMuch;
